<script lang="ts">
  import AvailableLocalesPartial from '../AvailableLocalesPartial/AvailableLocalesPartial.svelte';
  import ModalPartial from './ModalPartial.svelte';

  export let modalPartialConfig: ModalPartialConfig;
  export let countriesAndLangs: CountryAndLanguageNamesMap;
</script>

<ModalPartial {modalPartialConfig}>
  <AvailableLocalesPartial supportedCountriesAndLangs={countriesAndLangs} />
</ModalPartial>
